import { css } from '@emotion/css';

export const sidebarStyles = css`
  top: var(--ly-header-height, 0px);
  transition: 0.3s ease-in-out;
`;

export const overflowUnset = css`
  overflow: unset !important;
`;

export const topZero = css`
  top: 0;
`;
